<template>
  <div class="record-chart">
    <div class="record-table">
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <span v-if="item.field == 'versionNo'">
              <a @click="viewVision(row)" href="#">{{ row[item.field] }}</a></span
            >
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { chartColumns } from './index.js';
  export default {
    name: 'ChangeRecordChart',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        columnList: [],
        load: false,
      };
    },
    mounted() {
      this.columnList = chartColumns;
    },
    methods: {
      fullTableData(tableData) {
        this.tableData = tableData;
      },
      // 列表双击
      dblclickEvent({ row }) {
        console.log(row, '信息');
        const path = {
          path: '/warehouse/contractDetail',
          name: 'contractDetail',
          meta: {
            keepAlive: true,
            title: '合同详情',
          },
          query: {
            id: row.contractId,
            pageMode: 1,
            history: true,
            isEdit: false,
          },
        };
        this.$router.push(path);
      },
      // 点击版本号查看历史版本
      viewVision(row) {
        const path = {
          path: '/warehouse/contractDetail',
          name: 'contractDetail',
          meta: {
            keepAlive: true,
            title: '合同详情',
          },
          query: {
            id: row.contractId,
            pageMode: 1,
            history: true,
            isEdit: false,
          },
        };
        this.$router.push(path);
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .record-chart {
    background: #fff;

    .record-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
  a {
    color: blue;
  }
</style>
